"use client";

import { ProductArProvider } from "@/lib/providers/ProductArProvider";

export default function ProductPageArShell({ children }) {
  return <ProductArProvider>{children}</ProductArProvider>;
}
